<template>
  <div class="tableWithPerPageSelection">
    <form @submit.prevent="recherche()" class="columns">
      <div class="column is-3">
        <b-field>
          <b-input :placeholder="$t('general.button.search')"
                   type="search"
                   icon="magnify"
                   class="inputSearch"
                   v-model="critereRecherche.auto">
          </b-input>
          <p class="control">
            <button class="button is-primary">
              {{ $t('general.button.search')}}
            </button>
          </p>
        </b-field>
      </div>
    </form>
    <div class="level">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <div class="card pd-10px">
              {{ $t('enCoursTiers.soldeTotal') }}
              <span :class="soldeAtInfiniteDay >= 0
              ? 'has-text-success' : 'has-text-danger'">
              {{ soldeAtInfiniteDay | formatDevise }}
              </span>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="card pd-10px">
              {{ soldeTiersInfo >= 0 ? $t('enCoursTiers.soldeSuperieur', {date: dateJour })
              : $t('enCoursTiers.soldeInferieur', {date: dateJour }) }}
              <span :class="soldeTiersInfo >= 0
              ? 'has-text-success' : 'has-text-danger'">
              {{ soldeTiersInfo | formatDevise }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow has-text-primary">
          <a @click="changeParameterQuery()" class="mgr-10px">
          <span class="has-text-primary" v-if="affLettre">
            {{ $t('enCoursTiers.masquer') }}
          </span>
            <span class="has-text-primary" v-if="!affLettre">
            {{ $t('enCoursTiers.afficher') }}
          </span>
          </a>
        </div>
        <div class="column is-narrow pdl-0">
          <exportExcelButton
            :perm="permRemisesOrLot.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url="" :columns="columns" :options="options" :ref="referenceTable"
      @loaded="finLoading" @loading="debutLoading"
      v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="libelle" slot-scope="props" class="is-pulled-left">

        <router-link-blank v-if="getNameRoute(props.row) !== null"
          :to="getNameRoute(props.row)"
          :message="props.row.libelle"/>
        <span v-else>{{ props.row.libelle }}</span>
      </div>
      <div slot="credit" slot-scope="props" class="is-pulled-right">
        {{ props.row.credit | formatDevise}}
      </div>
      <div slot="debit" slot-scope="props" class="is-pulled-right">
        {{ props.row.debit | formatDevise}}
      </div>
      <div slot="resteALettrer" slot-scope="props" class="is-pulled-right">
        {{ props.row.resteALettrer | formatDevise}}
      </div>
      <div slot="dateMouvement" slot-scope="props" class="is-pulled-left">
        {{ props.row.dateMouvement | formatDate }}
      </div>
      <div slot="etatLettrage" slot-scope="props" class="is-pulled-left">
        {{ $t(importedFunction.formatEtatLettrage(props.row.etatLettrage)) }}
      </div>
      <div slot="action" slot-scope="props" class="has-text-centered">
        <router-link class="button is-primary is-fullwidth"
                     :class="[{ 'button-access-no-permission' :
                     !checkPermissions(permRemisesOrLot.maj) || isEscompte(props.row)},
                     { 'pointer-events-none' :
                     !checkPermissions(permRemisesOrLot.maj) || isEscompte(props.row)}]"
                     :to="{
                     name: 'm.bodac.remises_bancaires-client',
                     params: { id: props.row.id, isFromDetailClient: isFromDetailClient} }">
          {{ props.row.etatLettrage === lettre ? $t('enCoursTiers.delettreAction')
          : $t('enCoursTiers.lettreAction') }}
        </router-link>
      </div>
      <div slot="commentaire" slot-scope="props" class="colonne-selected">
        <div v-if="props.row.commentaire" class="mgt-5px">
            <b-tooltip class="width-100percent"
                    multiline
                    type="is-warning"
                    position="is-left">
              <template v-slot:content>
                <div class="is-pre">{{props.row.commentaire}}</div>
              </template>
              <b-icon icon="alert" custom-size="mdi-24px" type="is-warning">
              </b-icon>
            </b-tooltip>
          </div>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatEtatLettrage from '@/services/general/formatEtatLettrage';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { LETTRE, LETTRE_PARTIELLEMENT, NON_LETTRE } from '@/configuration/lettrageConf';
import { FACTURES, REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ENCOURS } from '@/configuration/general/referenceTableConf';
import { MODULE_TLPE, MODULE_ACHAT } from '@/configuration/devisConf';

const MouvementsClient = createNamespacedHelpers('mouvementClient');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'enCoursTiers',
  props: {
    tiersId: String,
    soldeTiersInfo: Number,
    soldeAtInfiniteDay: {
      type: Number,
      required: true,
    },
    tiersInformation: Object,
    isFromDetailClient: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    routerLinkBlank,
    TableItemsInView,
    parametrageTable,
    exportExcelButton,
  },
  data() {
    return {
      dateJour: formatDate(new Date()),
      affLettre: false,
      critereRecherche: {},
      importedFunction: {
        formatEtatLettrage,
      },
      lettre: LETTRE,
      permFactures: FACTURES,
      permRemisesOrLot: this.isFromDetailClient ? REMISES_BANCAIRES : LOT_PAIEMENT,
      referenceTable: REFERENCE_TABLE_ENCOURS,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
    };
  },
  methods: {
    ...MouvementsClient.mapActions({
      actionsLoadMouvement: 'loadMouvementsClient',
    }),
    changeParameterQuery() {
      this.affLettre = !this.affLettre;
      this.recherche();
    },
    getNameRoute(mouvementClient) {
      switch (mouvementClient.typeDePiece) {
        case mouvementClientConf.FACTURE:
        case mouvementClientConf.AVOIR:
        case mouvementClientConf.ACOMPTE:
          return { name: 'c.bodac.factures', params: { id: mouvementClient.facture.id } };
        case mouvementClientConf.REGLEMENT:
          return {
            name: 'c.bodac.remises_bancaires',
            params: { id: mouvementClient.remiseBancaireId },
          };
        case mouvementClientConf.CHARGE:
        case mouvementClientConf.AVOIR_DE_CHARGE:
          if (mouvementClient.facture.module === MODULE_TLPE) {
            return {
              name: 'c.gabed.titre_recette',
              params: { id: mouvementClient.factureId },
            };
          }
          if (mouvementClient.facture.module === MODULE_ACHAT) {
            return {
              name: 'c.achat.factures',
              params: { id: mouvementClient.factureId },
            };
          }
          return { name: 'c.baux.facture_achat', params: { id: mouvementClient.facture.id } };
        case mouvementClientConf.PAIEMENT:
          if (mouvementClient.remiseBancaire.module === MODULE_TLPE) {
            return {
              name: 'c.gabed.lot_paiement_recette',
              params: { id: mouvementClient.remiseBancaireId },
            };
          }
          if (mouvementClient.facture.module === MODULE_ACHAT) {
            return {
              name: 'c.achat.lot_paiements_factures',
              params: { id: mouvementClient.remiseBancaireId },
            };
          }
          return {
            name: 'c.baux.lot_paiement',
            params: { id: mouvementClient.remiseBancaireId },
          };
        case mouvementClientConf.OD:
          return {
            name: 'c.comptabilite.operation_diverse',
            params: { id: mouvementClient.operationDiverseId },
          };
        default: return null;
      }
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    isEscompte(mouvementClient) {
      if (mouvementClient === undefined || MouvementsClient === null) return false;
      return mouvementClient.typeDePiece === mouvementClientConf.ESCOMPTE;
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...MouvementsClient.mapGetters({
      items: 'items',
      total: 'total',
    }),
    columns() {
      return ['dateMouvement', 'libelle', 'debit', 'credit', 'resteALettrer', 'etatLettrage', 'action', 'commentaire'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateMouvement: this.$i18n.t('enCoursTiers.date'),
          libelle: this.$i18n.t('enCoursTiers.libelle'),
          debit: this.$i18n.t('enCoursTiers.debit'),
          credit: this.$i18n.t('enCoursTiers.credit'),
          resteALettrer: this.$i18n.t('enCoursTiers.resteAlettrer'),
          etatLettrage: this.$i18n.t('enCoursTiers.etat'),
          action: this.$i18n.t('enCoursTiers.action'),
          commentaire: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['dateMouvement', 'libelle', 'debit', 'credit', 'resteALettrer', 'etatLettrage'],
        columnsClasses: {
          action: 'colonneAction',
          commentaire: 'colonneSelected',
        },
        requestFunction: ((ObjectFilter) => {
          ObjectFilter.query = {
            tiersId: this.tiersId,
            brouillard: false,
            auto: this.critereRecherche.auto,
          };
          if (this.affLettre) {
            ObjectFilter.query.etatLettrage = [LETTRE_PARTIELLEMENT, NON_LETTRE, LETTRE];
          } else {
            ObjectFilter.query.etatLettrage = [LETTRE_PARTIELLEMENT, NON_LETTRE];
          }
          ObjectFilter.query.societeId = this.societeActiveId;
          return this.actionsLoadMouvement(ObjectFilter);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.total,
          };
        }),
      };
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
  },
};
</script>

<style scoped>

</style>
